export default "__VITE_ASSET__2c551c55__"